(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-cm-product]').forEach(section => {
      if (section.dataset.cmReady) return;
      section.dataset.cmReady = 'true';
      const gallery = section.querySelector('[data-cm-gallery]');
      const slides = [...gallery.children];
      const thumbs = [...section.querySelectorAll('[data-cm-slide]')];
      const motion = () => matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
      const show = i => { if (slides[i]) gallery.scrollTo({left:slides[i].offsetLeft-slides[0].offsetLeft,behavior:motion()}); };
      thumbs.forEach(button => button.addEventListener('click',() => show(Number(button.dataset.cmSlide))));
      gallery.addEventListener('scroll', () => {
        const i = Math.round(gallery.scrollLeft/gallery.clientWidth);
        thumbs.forEach((button,n) => button.setAttribute('aria-current',String(n===i)));
      },{passive:true});
      gallery.addEventListener('keydown', e => {
        if (!['ArrowLeft','ArrowRight'].includes(e.key)) return;
        e.preventDefault();const i=Math.round(gallery.scrollLeft/gallery.clientWidth)+(e.key==='ArrowRight'?1:-1);
        show(Math.max(0,Math.min(slides.length-1,i)));
      });
      const form = section.querySelector('form');
      if (!form) return;
      const field = form.querySelector('[name="id"]');
      let variants=[];
      try { variants=JSON.parse(form.querySelector('[data-cm-variants]')?.textContent||'[]'); }catch{}
      const lookup=new Map(variants.map(v => [String(v.id),v]));
      const filename = v => String(v||'').split('?')[0].split('/').pop();
      const update = (id,move=true) => {
        const v=lookup.get(String(id));if(!v)return;
        section.querySelectorAll('[data-cm-variant]').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.cmVariant===String(id))));
        section.querySelector('[data-cm-color]').textContent=v.title;
        const add=form.querySelector('[name="add"]');if(add)add.disabled=!v.available;
        if(move&&v.featured_image){const n=slides.findIndex(s=>String(s.dataset.mediaId)===String(v.featured_media?.id)||filename(s.dataset.src)===filename(v.featured_image.src));if(n>=0)show(n);}
      };
      section.querySelectorAll('[data-cm-variant]').forEach(b=>b.addEventListener('click',()=>{
        field.value=b.dataset.cmVariant;field.dispatchEvent(new Event('change',{bubbles:true}));
        const url=new URL(location.href);url.searchParams.set('variant',field.value);history.replaceState({},'',url);update(field.value);
      }));
      section.addEventListener('change',e=>{if(e.target.matches('[name="id"]'))update(e.target.value);});
      let previous=field.value;update(previous,false);
      const extract = value => {
        if(value&&typeof value==='object'){for(const child of Object.values(value)){const id=extract(child);if(id)return id;}}
        else if(lookup.has(String(value)))return String(value);
        return null;
      };
      const widgets=new WeakSet();
      const bind = () => section.querySelectorAll('kaching-bundle,kaching-bundles-block').forEach(widget=>{
        if(widgets.has(widget))return;widgets.add(widget);
        ['variant-selected','variants-changed'].forEach(type=>widget.addEventListener(type,e=>{const id=extract(e.detail);if(id)update(id);}));
      });
      bind();const observer=new MutationObserver(bind);observer.observe(section,{childList:true,subtree:true});
      const watcher=setInterval(()=>{if(!section.isConnected){clearInterval(watcher);observer.disconnect();return;}if(field.value!==previous){previous=field.value;update(previous);}},300);
    });
    root.querySelectorAll('.cm-video-card').forEach(card=>{
      if(card.dataset.cmReady)return;card.dataset.cmReady='true';
      const video=card.querySelector('video'),button=card.querySelector('[data-cm-play]');
      button.addEventListener('click',()=>{video.play().catch(()=>{});});
      video.addEventListener('play',()=>{button.hidden=true;root.querySelectorAll('.cm-video-card video').forEach(other=>{if(other!==video)other.pause();});});
      video.addEventListener('pause',()=>{button.hidden=false;});video.addEventListener('ended',()=>{button.hidden=false;});
    });
    root.querySelectorAll('[data-cm-review-list]').forEach(list=>{
      if(list.dataset.cmReady)return;list.dataset.cmReady='true';
      const container=list.closest('section'),rows=[...list.children],prev=container.querySelector('[data-cm-review-prev]'),next=container.querySelector('[data-cm-review-next]'),label=container.querySelector('[data-cm-review-page]');
      let page=0;const pages=Math.max(1,Math.ceil(rows.length/6));
      const show=()=>{rows.forEach((r,i)=>r.hidden=Math.floor(i/6)!==page);prev.disabled=page===0;next.disabled=page===pages-1;label.textContent=String(page+1);};
      prev.addEventListener('click',()=>{page=Math.max(0,page-1);show();});next.addEventListener('click',()=>{page=Math.min(pages-1,page+1);show();});show();
    });
    root.querySelectorAll('[data-sale-end]').forEach(timer=>{
      if(timer.dataset.cmReady)return;timer.dataset.cmReady='true';
      const end=Date.parse(timer.dataset.saleEnd);if(!Number.isFinite(end))return;
      const refresh=()=>{const remaining=Math.max(0,Math.floor((end-Date.now())/1000));timer.hidden=remaining===0;if(!remaining)return;const vals={days:Math.floor(remaining/86400),hours:Math.floor(remaining/3600)%24,minutes:Math.floor(remaining/60)%60,seconds:remaining%60};Object.entries(vals).forEach(([key,value])=>timer.querySelector(`[data-${key}]`).textContent=String(value).padStart(2,'0'));};
      refresh();const ticker=setInterval(()=>{if(!timer.isConnected){clearInterval(ticker);return;}refresh();},1000);
    });
  };
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init());else init();
  document.addEventListener('shopify:section:load',e=>init(e.target.parentElement));
})();
